<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.memo')"
    resource="memos"
    :actionColumnProps="{ width: 200 }"
  />
</template>

<script>
import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/memos.js';
import Utils from '../components/utils.vue';
@Component
export default class Memos extends Mixins(Vue, Utils) {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'content_cont',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'customer',
      { key: 'remind_at', width: 200 },
      'content',
      { key: 'is_reminded', width: 120 },
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      {
        key: 'customer_id',
        renderCell: {
          props: {
            options: this.defaultCustomerOptions,
            xRemotePreload: async () => {
              return (await this.$request.get('customers/read_options', { per_page: 100, ...this.customerOptionsFilter })).data.map(item => ({ value: item.id, label: item.name }));
            },
            xRemoteSearch: async (keyword) => {
              return (await this.$request.get('customers/read_options', { keyword, ...this.customerOptionsFilter })).data.map(item => ({ value: item.id, label: item.name }));
            }
          },
          domProps: {
            style: 'width: 100%'
          }
        }
      },
      'remind_at',
      'content',
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      !row.is_reminded && {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'memos.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'memos.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/memos',
    name: 'memos.index',
    component: Memos,
    props: {
      type: 'index',
    }
  },
  {
    path: '/memos/new',
    name: 'memos.new',
    component: Memos,
    props: {
      type: 'new',
    }
  },
  {
    path: '/memos/:id',
    name: 'memos.show',
    component: Memos,
    props: {
      type: 'show',
    }
  },
  {
    path: '/memos/:id/edit',
    name: 'memos.edit',
    component: Memos,
    props: {
      type: 'edit'
    }
  }
]
</script>
